import axios from 'axios';
import { API_URL } from '../config/constants';
import { crypt } from '../utils/crypt_api';

// Crea una instancia de Axios con la configuración base
const axiosInstance = axios.create({
    baseURL: API_URL,
});

// Agrega un interceptor para las solicitudes
axiosInstance.interceptors.request.use(function (config) {
    // config.headers['Access-Control-Allow-Origin'] = process.env.REACT_APP_ACCESS_CONTROL_ALLOW;
    // config.headers['Access-Control-Allow-Methods'] = 'POST, GET, PUT, OPTIONS';
    // config.headers['Encrypted-Route'] = crypt(config.url);
    // config.headers['Content-Type'] = 'application/json';
    // config.url = API_URL + '/handle';
    return config;
}, function (error) {
    // Maneja errores de solicitud
    return Promise.reject(error);
});

export default axiosInstance;